import React, { ChangeEvent, useState } from 'react'
import RegionList from '@/resources/RegionList.json'
import '@/App.css'
import ImageView from '@/views/ImageView'
import Ad from './views/Ad'

const CHOICE = Object.freeze({
  YES: 1,
  NO: 0,
  UNKNOWN: 2
})

const QUESTIONS = Object.freeze([
  {
    index: 0,
    name: 'water',
    question: '水（海・川・池など）はある？'
  },
  {
    index: 1,
    name: 'mountain',
    question: '山はある？'
  },
  {
    index: 2,
    name: 'tree',
    question: '森や木（ヤシの木・モミの木含む）はある？'
  },
  {
    index: 3,
    name: 'road',
    question: '道はある？'
  },
  {
    index: 4,
    name: 'ramp',
    question: '坂はある？'
  },
  {
    index: 5,
    name: 'bridge',
    question: '橋はある？'
  },
  {
    index: 6,
    name: 'bulletin-board',
    question: '立て札はある？'
  },
  {
    index: 7,
    name: 'ford',
    question: '浅瀬はある？'
  },
  {
    index: 8,
    name: 'poison-swamp',
    question: '毒沼はある？'
  },
  {
    index: 9,
    name: 'dead-tree',
    question: '枯れ木はある？'
  }
])

const App = () => {
  // #region フック

  const [selectedRegion, setSelectedRegion] = useState(0)

  const [states, setStates] = useState<number[]>(QUESTIONS.map(() => CHOICE.UNKNOWN))

  const partsStates = QUESTIONS.map((q, i) => ({
    index: q.index,
    name: q.name,
    question: q.question,
    state: states[i],
    setState: (value: number) => {
      setStates((prev) => {
        const newStates = [...prev]
        newStates[i] = value
        return newStates
      })
    }
  }))

  const [is234] = useState(() => Math.random() < 0.5)

  // #endregion フック

  // #region スタイル

  const adAreaStyle: React.CSSProperties = {
    textAlign: 'center'
  }

  const adHeadlineStyle: React.CSSProperties = {
    margin: '8px 0 0 0',
    fontSize: '20px',
    fontFamily: 'Meiryo',
    fontWeight: 'bold'
  }

  const adMainStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  }

  const hrStyle: React.CSSProperties = {
    marginLeft: '18px'
  }

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  const displayStyle: React.CSSProperties = {
    display: 'flex'
  }

  const questionStyle: React.CSSProperties = {
    width: '320px',
    height: 'calc(100vh - 320px)',
    border: 'solid 1px',
    paddingLeft: '10px',
    overflowY: 'scroll'
  }

  const pulldownStyle: React.CSSProperties = {
    fontSize: '15px',
    height: '24px'
  }

  const imageStyle: React.CSSProperties = {
    width: 'calc(81vw - 5px)',
    height: 'calc(100vh - 320px)',
    border: 'solid 1px',
    overflowY: 'scroll',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start'
  }

  // #endregion スタイル

  // #region イベント

  const onChangeRegion = (e: ChangeEvent<HTMLSelectElement>) => {
    setSelectedRegion(parseInt(e.target.value))
  }

  const onChangeRadio = (e: ChangeEvent<HTMLInputElement>) => {
    const idx = parseInt(e.target.name.replace('q', ''))
    partsStates[idx].setState(parseInt(e.target.value))
  }

  // #endregion イベント

  // 入力フォーム部分
  const questionsView = partsStates.map((s) => (
    <React.Fragment key={`q${s.index}`}>
      <p>{`${s.index + 1}. ${s.question}`}</p>
      <div>
        <input
          type='radio'
          id={`${s.name}-yes`}
          name={`q${s.index}`}
          value={CHOICE.YES}
          onChange={onChangeRadio}
          checked={s.state === CHOICE.YES}
        />
        <label htmlFor={`${s.name}-yes`}>はい</label>
      </div>
      <div>
        <input
          type='radio'
          id={`${s.name}-no`}
          name={`q${s.index}`}
          value={CHOICE.NO}
          onChange={onChangeRadio}
          checked={s.state === CHOICE.NO}
        />
        <label htmlFor={`${s.name}-no`}>いいえ</label>
      </div>
      <div>
        <input
          type='radio'
          id={`${s.name}-unknown`}
          name={`q${s.index}`}
          value={CHOICE.UNKNOWN}
          onChange={onChangeRadio}
          checked={s.state === CHOICE.UNKNOWN}
        />
        <label htmlFor={`${s.name}-unknown`}>わからない</label>
      </div>
      <br />
    </React.Fragment>
  ))

  return (
    <>
      <div style={adAreaStyle}>
        <p style={adHeadlineStyle}>広告</p>
        {is234 ? (
          <div style={adMainStyle}>
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
            <Ad width={234} height={60} />
          </div>
        ) : (
          <div style={adMainStyle}>
            <Ad width={468} height={60} />
            <Ad width={468} height={60} />
          </div>
        )}
      </div>
      <hr style={hrStyle} />
      <div style={spaceStyle}>
        <h1>ドラゴンクエスト9 宝の地図場所特定ツール</h1>
        <div style={spaceStyle}>
          探している地図について、左の質問に答えてください。「わからない」以外を選ぶと右側の画像の数が減っていくため絞りやすくなります。
          <br />
          地図をクリックすると場所や詳細情報を確認することができます。
          <hr />
          <div style={displayStyle}>
            <div style={questionStyle}>
              <p>0. 地名は分かる？</p>
              <select style={pulldownStyle} onChange={onChangeRegion}>
                <option value='0'>--選択してください--</option>
                {RegionList.regions.map((s, i) => (
                  <option key={i + 1} value={`${i + 1}`}>
                    {s}
                  </option>
                ))}
              </select>
              {questionsView}
            </div>
            <div style={imageStyle}>
              <ImageView selectedRegion={selectedRegion} partsStates={partsStates} />
            </div>
          </div>
          <hr />
          <a href='/tools'>ツール置き場に戻る</a>
          {'　|　'}
          <a href='/'>トップページに戻る</a>
          {'　|　'}
          <a href='/blog/hello-world'>運営者情報</a>
          {'　|　'}
          <a href='/blog/privacypolicy'>プライバシーポリシー</a>
        </div>
      </div>
    </>
  )
}

export default App
